export function pdfChecker(url) {
  return url?.match(/\.(pdf|PDF)$/) ? true : false;
}

export function getFileExtension(url) {
  // Get the part of the URL after the last "/"
  const fileName = url?.split("/").pop();

  // Split the file name by "."
  const parts = fileName?.split(".");

  // If there's more than one part, the last one is the extension
  if (parts.length > 1) {
    return parts.pop().toLowerCase(); // The file extension (e.g., 'pdf')
  } else {
    return null; // No extension found
  }
}
